import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "@/store/store";

interface EmailProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const EmailProtectedRoute: React.FC<EmailProtectedRouteProps> = ({
  children,
  redirectTo = "/",
}) => {
  const userData = useSelector((state: RootState) => state.auth.userData);

  const isAdmin = userData?.roles?.includes("admin");

  if (!isAdmin) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
